<template>
  <div
    class="form-control"
    :class="{
      'has-icon': icon,
      'focused': isFocused,
      'disabled': disabled,
      'i18n': i18n,
      'has-error': error
    }">
    <select 
      class="locale-picker" 
      v-model="currentLocale" 
      v-if="i18n" 
      tabindex="-1">
      <option 
        v-for="locale in locales" 
        :key="locale.key"
        :value="locale.key"
        :selected="locale.default">{{ locale.key }}</option>
    </select>
    <input
      :type="type"
      :value="computedValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :step="step"
      v-bind="$attrs"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur" />
    <div class="icon" v-if="icon">
      <slot name="icon" />
    </div>
  </div>
</template>

<script>
import { locales } from '@/i18n'
import { isObject } from '@/utils'

export default {
  props: {
    value: [Number, String, Object],
    type: {
      type: String,
      default: "text"
    },
    i18n: Boolean,
    placeholder: String,
    disabled: Boolean,
    icon: Boolean,
    error: Boolean,
    step: [Number, String]
  },
  data() {
    let strings = this.value
    if (!isObject(this.value)) {
      strings = {}
      locales.forEach(locale => {
        strings[locale.key] = ''
      })
    }

    return {
      newValue: this.value,
      isFocused: false,
      locales,
      currentLocale: locales.find(locale => locale.default).key,
      strings
    }
  },
  methods: {
    onInput(e) {
      this.computedValue = e.target.value;
    },
    onFocus() {
      this.isFocused = true
      this.$emit("focus")
    },
    onBlur() {
      this.isFocused = false
      this.$emit("blur")
    }
  },
  computed: {
    computedValue: {
      get() {
        if (this.i18n) {
          return this.strings[this.currentLocale]
        } else {
          return this.newValue;
        }
      },
      set(value) {
        if (this.i18n) {
          this.strings[this.currentLocale] = value;

          let output = {...this.strings}
          const defaultLocale = locales.find(locale => locale.default)
          for (let key in output) {
            if (output[key] === '' && key !== defaultLocale.key) {
              output[key] = output[defaultLocale.key];  
            }
          }
          this.$emit("input", output)
        } else {
          this.newValue = value;
          this.$emit("input", value);
        }
      },
    },
  },
  watch: {
    value(value) {
      if (!this.i18n) {
        this.newValue = value
      }
    }
  }
}
</script>